export default __webpack_public_path__ + "static/media/synergy-one-logo-square-black.3edc6adc.svg";